import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import RadioBlock from '../../../../../../../../../components/Form/RadioBlock'
import Field from '../../../../../../../../../components/Form/Field'

import { selectedFacebookAdAccountSelector } from '../../../../../../../../../modules/selectors/adAccounts'
import { choicesPixelsLoadingSelector } from '../../../../../../../../../modules/selectors/choices'

import { PROMOTED_PIXEL } from '../../../../../../../../../constants/selectLists/customEventTypes/fields'
import { TARGET_COST_CAP } from '../../../../../../../../Multiplatform/LineItemForms/fields'
import {
  ARE_WE_ABLE_TO_TRACK_LANDING_PAGE_VIEWS,
  NO_I_HAVE_NOT_LINKED_BY_WEBSITE_PIXEL,
  YES_I_HAVE_LINKED_BY_WEBSITE_PIXEL
} from '../../../../fields'

import useDrawerFormStyles from '../../../../../../../../../styles/common/drawerForms'

const TrafficObjectivePromotedObjectFields = ({ formik, formattedPixels, showTargetCostCapField }) => {
  const drawerFormClasses = useDrawerFormStyles()
  const { t } = useTranslation()

  const { currency_symbol: currencySymbol } = useSelector(selectedFacebookAdAccountSelector)
  const pixelsIsLoading = useSelector(choicesPixelsLoadingSelector)

  const { values, setFieldValue } = formik

  const trafficSectionTitle = useMemo(() => {
    if (values[ARE_WE_ABLE_TO_TRACK_LANDING_PAGE_VIEWS] === YES_I_HAVE_LINKED_BY_WEBSITE_PIXEL) {
      return 'Please enter a cost per landing page view goal'
    } else {
      return 'Please enter a cost per click goal'
    }
  }, [values])

  return (
    <>
      <RadioBlock
        setFieldValue={setFieldValue}
        id={NO_I_HAVE_NOT_LINKED_BY_WEBSITE_PIXEL}
        name={ARE_WE_ABLE_TO_TRACK_LANDING_PAGE_VIEWS}
        label={t('No, I have not linked my website pixel and want to optimise towards clicks')}
        value={NO_I_HAVE_NOT_LINKED_BY_WEBSITE_PIXEL}
        selectedValue={values[ARE_WE_ABLE_TO_TRACK_LANDING_PAGE_VIEWS]}
      />
      <RadioBlock
        setFieldValue={setFieldValue}
        id={YES_I_HAVE_LINKED_BY_WEBSITE_PIXEL}
        name={ARE_WE_ABLE_TO_TRACK_LANDING_PAGE_VIEWS}
        label={t('Yes, I have linked my website pixel')}
        value={YES_I_HAVE_LINKED_BY_WEBSITE_PIXEL}
        selectedValue={values[ARE_WE_ABLE_TO_TRACK_LANDING_PAGE_VIEWS]}
      >
        <Field
          placeholder={t('Event Source')}
          formik={formik}
          name={PROMOTED_PIXEL}
          options={formattedPixels}
          isLoading={pixelsIsLoading}
          preselectFirstOptionValue
        />
      </RadioBlock>
      {showTargetCostCapField && (
        <>
          <h3 className={drawerFormClasses.sectionTitle}>{trafficSectionTitle}</h3>
          <p>{t('If this is set too low, it may limit delivery of the campaign.')}</p>
          <Field
            type="number"
            formik={formik}
            name={TARGET_COST_CAP}
            placeholder={t('Cost per click goal')}
            symbol={currencySymbol}
            autoComplete="off"
          />
        </>
      )}
    </>
  )
}

TrafficObjectivePromotedObjectFields.propTypes = {
  formik: PropTypes.object.isRequired,
  formattedPixels: PropTypes.array.isRequired,
  showTargetCostCapField: PropTypes.bool.isRequired
}

export default TrafficObjectivePromotedObjectFields
